if (!customElements.get('lp2-final-pricing-atc')) {
  customElements.define(
    'lp2-final-pricing-atc',
    class Lp2FinalPricingAtc extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onCartRequestEnd = this.onCartRequestEnd.bind(this);
        this.pendingButton = null;
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        document.addEventListener('liquid-ajax-cart:request-end', this.onCartRequestEnd);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('liquid-ajax-cart:request-end', this.onCartRequestEnd);
      }

      setLoading(button, loading) {
        if (!button) {
          return;
        }

        const isAvailable = button.dataset.lp2Available === 'true';

        button.classList.toggle('is-loading', loading);
        button.setAttribute('aria-busy', loading ? 'true' : 'false');
        button.disabled = loading || !isAvailable;
      }

      clearLoading() {
        if (!this.pendingButton) {
          return;
        }

        this.setLoading(this.pendingButton, false);
        this.pendingButton = null;
      }

      onCartRequestEnd(event) {
        const { requestState } = event.detail || {};

        if (!this.pendingButton) {
          return;
        }

        if (requestState?.info?.initiator !== this) {
          return;
        }

        if (requestState?.requestType !== 'add') {
          return;
        }

        this.clearLoading();
      }

      onClick(event) {
        const button = event.target.closest('[data-lp2-atc]');

        if (!button || button.disabled || this.pendingButton) {
          return;
        }

        const action = button.dataset.lp2Atc;
        const primaryId = Number(this.dataset.primaryVariantId);
        const addonId = Number(this.dataset.bundleAddonVariantId);

        if (!primaryId) {
          return;
        }

        const items =
          action === 'bundle'
            ? [
                { id: primaryId, quantity: 1 },
                { id: addonId, quantity: 1 },
              ]
            : [{ id: primaryId, quantity: 1 }];

        if (action === 'bundle' && !addonId) {
          return;
        }

        const ajaxAdd = window.liquidAjaxCart?.add;

        if (typeof ajaxAdd !== 'function') {
          return;
        }

        this.pendingButton = button;
        this.setLoading(button, true);

        ajaxAdd(
          { items },
          {
            info: { initiator: this },
          }
        );
      }
    }
  );
}
